import { render } from "./Submitted.vue?vue&type=template&id=6acec3ea"
import script from "./Submitted.vue?vue&type=script&lang=js"
export * from "./Submitted.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__